import { Text } from '@shared/components'
import { Card, CardProps, Flex } from 'antd'
import { ReactNode } from 'react'

type Props = {
  leadDetails: { icon: ReactNode; label?: string }[]
} & CardProps

export const InfoLeadCard = ({ leadDetails, ...props }: Props) => {
  return (
    <Card size="small" {...props}>
      <Flex vertical gap={12}>
        {leadDetails.map((item, index) => (
          <Flex align="center" gap={8} key={index}>
            {item.icon}
            <Text>{item.label}</Text>
          </Flex>
        ))}
      </Flex>
    </Card>
  )
}
